import { makeStyles } from "@material-ui/core";

const stylesModalConfiguracaoBuscaExternaStyles = makeStyles({
  textoDestaque: {
    fontWeight: "bold",
  },
  linhaDivisoria: {
    width: "100%", 
    margin: "1rem 0"
  },
  containerButtonReplicar: {
    display: 'flex', 
    alignItems: 'center'
  },
  containerIconeReplicar: {
    color: "#49B6E7", 
    '&:hover': {
      backgroundColor: "transparent"
    }
  },
  iconeReplicar: {
     marginRight: "0.8rem", 
     fontSize: "0.9rem" 
  },
  containerError: {
    display: "flex", 
    backgroundColor: "#ED55653B",
    borderRadius: "4px",
    marginTop: "5rem",
  },
  iconeError: {
    marginRight: "0.3rem",
    marginBottom: "0.2rem",
    fontSize: "1rem"
  },
  containerSessaoDuvida: {
    display: "flex", 
    alignItems: "center", 
    marginTop: "1.5rem",
  },
  iconeDuvida: {
    marginRight: "0.3rem", 
    marginBottom: "0.2rem", 
    fontSize: "0.8rem"
  },
  textoDuvida: {
    fontSize: "0.8rem"
  },
  linkDuvida: {
    color: "#337AB7"
  },
  linkError: {
    cursor: "pointer",
    fontWeight: "bold",
    textDecoration: "underline",
  }
})

export default stylesModalConfiguracaoBuscaExternaStyles;
